export const descData = [
    {
        key: "type",
        type: "props",
        parameterType: "String",
        desc: "类型",
        remark: "primary | success | warning | danger | info | default",
    },
    {
        key: "size",
        type: "props",
        parameterType: "String",
        desc: "尺寸",
        remark: "small | medium | mini | ''",
    },
    {
        key: "disabled",
        type: "props",
        parameterType: "Boolean",
        desc: "是否禁用",
        remark: "",
    },
    {
        key: "className",
        type: "props",
        parameterType: "String",
        desc: "自定义类名",
        remark: "",
    },
    {
        key: "plain",
        type: "props",
        parameterType: "Boolean",
        desc: "是否为朴素按钮",
        remark: "",
    },
    {
        key: "round",
        type: "props",
        parameterType: "Boolean",
        desc: "是否为圆角按钮",
        remark: "",
    },
    {
        key: "circle",
        type: "props",
        parameterType: "Boolean",
        desc: "是否为圆形按钮",
        remark: "",
    },
    {
        key: "text",
        type: "props",
        parameterType: "Boolean",
        desc: "是否为文字按钮",
        remark: "",
    },
    {
        key: "nativeType",
        type: "props",
        parameterType: "String",
        desc: "原生类型",
        remark: "",
    },
    {
        key: "icon",
        type: "props",
        parameterType: "String",
        desc: "图标",
        remark: "",
    },
    {
        key: "icon(slot)",
        type: "slot",
        parameterType: "",
        desc: "图标插槽",
        remark: "",
    },
    {
        key: "icon-right",
        type: "slot",
        parameterType: "",
        desc: "图标插槽(右)",
        remark: "",
    },
    {
        key: "default",
        type: "slot",
        parameterType: "",
        desc: "默认插槽",
        remark: "",
    }
]
